module.exports = __webpack_public_path__ + "img/ce.0c84f74e.svg";